<script>
import { mapActions, mapState } from "vuex"
import axios from "axios"
import { useProjectStore } from "@/store/modules/project"

export default {
  name: "DeviceListWarningBoxes",
  props: {
    technology: {
      type: String,
      required: true
    }
  },
  emits: ["setFilter"],
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      devicesOnInactiveServicesCount: 0,
      devicesOnSuspendedServicesCount: 0,
      isSuspendedDevicePresent: false,
      isFiltered: false
    }
  },
  watch: {
    async project() {
      this.getIsSuspendedDevicePresent()
      await this.getServices(this.projectStore.selectedProject.projectId, this.technology)
      this.getDevicesOnInactiveServicesCount()
    }
  },
  computed: {
    ...mapState({
      services: (state) => state.services.services
    }),
    inactiveServices() {
      return this.services.filter((service) => service.discontinued)
    },
    suspendedServices() {
      return this.services.filter((service) => service.suspended)
    }
  },
  async mounted() {
    if (this.projectStore.selectedProject.projectId) {
      this.getIsSuspendedDevicePresent()
      await this.getServices(this.projectStore.selectedProject.projectId, this.technology)
      this.getDevicesOnInactiveServicesCount()
    }
  },
  methods: {
    ...mapActions({
      getServices: "services/getServices"
    }),
    async getIsSuspendedDevicePresent() {
      const devices = await axios.get(
        `${process.env.VUE_APP_API}/${this.technology}/devices/?projectId[eq]=${
          this.projectStore.selectedProject.projectId
        }&suspended[eq]=1&t=${Date.now()}`
      )
      this.isSuspendedDevicePresent = devices.data.metadata.count > 0
    },
    async getDevicesOnInactiveServicesCount() {
      if (!this.services.length) {
        return
      }

      let inactiveCount = 0
      let suspendedCount = 0
      for (const service of this.services) {
        if (service.discontinued || service.suspended) {
          const devices = await axios.get(
            `${process.env.VUE_APP_API}/${this.technology}/devices?projectId[eq]=${this.projectStore.selectedProject.projectId}&custServiceId[eq]=${service.custServiceId}`
          )

          if (service.discontinued) {
            inactiveCount += devices.data.metadata.count
          }
          if (service.suspended) {
            suspendedCount += devices.data.metadata.count
          }
        }
      }
      this.devicesOnInactiveServicesCount = inactiveCount
      this.devicesOnSuspendedServicesCount = suspendedCount
    },
    setFilter(filter) {
      this.$emit("setFilter", filter)
      this.isFiltered = !!filter.length
    }
  }
}
</script>

<template>
  <div>
    <div v-if="devicesOnInactiveServicesCount" class="mb-3 box-danger font-weight-bold">
      {{ devicesOnInactiveServicesCount }}
      {{ $t("DEVICES_ON_INACTIVE_SERVICE") }}
      <a
        class="ml-2"
        @click="
          setFilter([
            {
              name: 'custServiceId',
              value: this.inactiveServices.map((service) => service.custServiceId).join(',')
            }
          ])
        "
      >
        {{ $t("zobrazit") }}
      </a>
    </div>
    <div v-if="devicesOnSuspendedServicesCount" class="mb-3 box-danger font-weight-bold">
      {{ devicesOnSuspendedServicesCount }}
      {{ $t("DEVICES_ON_SUSPENDED_SERVICE") }}
      <a
        class="ml-2"
        @click="
          setFilter([
            {
              name: 'custServiceId',
              value: this.suspendedServices.map((service) => service.custServiceId).join(',')
            }
          ])
        "
      >
        {{ $t("zobrazit") }}
      </a>
    </div>
    <div v-if="isSuspendedDevicePresent" class="mb-3 box-danger font-weight-bold">
      {{ $t("SUSPENDED_DEVICE_FOUND") }}
      <a class="ml-2" @click="setFilter([{ name: 'suspended', value: 1 }])">
        {{ $t("zobrazit") }}
      </a>
    </div>
    <div v-if="isFiltered" class="mb-5">
      <a class="ml-2 text-dark" @click="setFilter([])">
        {{ $t("REMOVE_FILTERS") }}
      </a>
    </div>
  </div>
</template>
